import React from "react";
import { Field } from "react-final-form";
import { MoneyInput } from "../../../components/inputs/final_form/MoneyInput";
import { LoadingButton } from "../../../components/LoadingButton";
import { atLeastOneFieldWithMoneyRequired, required } from "../../../util/validators";
import { AdministrateSelectInput } from "../../components/inputs/AdministrateSelectInput";

export const NonCoveredPricingForm = ({ handleSubmit, submitting }) => {
  return (
    <>
      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/cpt_codes.json"
        label="CPT Code"
        name="cptCodeId"
        required
        validate={required}
      />

      <Field component={AdministrateSelectInput} resourceUrl="/admin/payors.json" label="Payor" name="payorId" searchParam="name" />

      <Field
        component={AdministrateSelectInput}
        resourceUrl="/admin/enums/plan_type_groups.json"
        label="Plan Type"
        name="planType"
        labelKey="label"
        valueKey="id"
      />

      <Field component={MoneyInput} validate={atLeastOneFieldWithMoneyRequired("medicarePercentage")} label="Price" name="priceCents" />

      <LoadingButton loading={submitting} onClick={handleSubmit} disabled={submitting}>
        Submit
      </LoadingButton>
    </>
  );
};
